import { ReleaseNotesButton } from './ReleaseNotesButton'

export default ReleaseNotesButton
